import React from 'react';
import styled from 'styled-components';

import { colors, animation } from '../styles/constants';
import { T2D, T2R } from '../components/Text';

const { shortAnimationDuration, transitionTimingFn } = animation;

const SubscribeFormContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 2rem;
`;

const Form = styled.form`
  display: flex;
  max-width: 46rem;
  background-color: ${colors.blue};
  padding: 1rem;
  border: solid 0.3rem ${colors.white};
`;

const Input = styled.input.attrs({
  type: 'email',
  placeholder: 'Your email here',
  'aria-label': 'Email input to subscribe to the Small Planet newsletter'
})`
  font-family: 'AvenirNext';
  font-weight: 400;
  font-size: 2.2rem;
  color: ${colors.white};
  background-color: ${colors.blue};
  width: 75%;
  padding: 0;
  margin-right: 1rem;

  border: none;
  border-radius: 0;

  ::placeholder {
    color: ${colors.white};
    opacity: 0.6;
  }
`;

const HiddenDiv = styled.div`
  position: absolute;
  left: -5000px;
`;

const Submit = styled.input`
  color: ${colors.white};
  padding: 0;
  border: none;
  background-color: ${colors.blue};
  margin-left: auto;
  opacity: 1;
  border-radius: 0;
  transition: opacity ${shortAnimationDuration}ms ${transitionTimingFn};
  -webkit-appearance: none;

  &:hover,
  &:focus,
  &:active {
    opacity: 0.9;
  }
`;

const SubscribeForm = () => (
  <SubscribeFormContainer>
    <DescriptionContainer>
      <T2D color={colors.white}>Subscribe to Observatory</T2D>
      <T2R color={colors.white}>Small Planet Links, News, and Observations</T2R>
    </DescriptionContainer>
    <Form
      action="//smallplanet.us2.list-manage.com/subscribe/post?u=388c8f528913b71b9fbf39035&amp;id=e46406bc08"
      method="post"
      target="_blank"
      rel="noopener noreferrer"
      novalidate
    >
      <HiddenDiv aria-hidden="true">
        <input
          type="text"
          name="b_388c8f528913b71b9fbf39035_e46406bc08"
          tabIndex="-1"
        />
      </HiddenDiv>
      <Input name="EMAIL" required />
      <Submit
        type="submit"
        value="Get It"
        aria-label="Subscribe to the Small Planet newsletter"
      />
    </Form>
  </SubscribeFormContainer>
);

export default SubscribeForm;
